module.exports = __webpack_public_path__ + "img/0Q3A3375_L_BlackMatted.aef91294.jpg";